import { getATLContextDomain, getATLContextUrl } from '@atlassian/atl-context';

import { isFedramp } from '../config';

export function getAtlassianContextUrl(domainKey: string): string {
	if (isFedramp()) {
		return getATLContextUrl(domainKey);
	} else {
		return `https://${domainKey}.atlassian.com`;
	}
}

export function getAtlassianContextDomain(domainKey: string): string {
	if (isFedramp()) {
		return getATLContextDomain(domainKey);
	} else {
		return `${domainKey}.atlassian.com`;
	}
}
